/*
 * This file is part of glowingblue/datavis.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Component from 'flarum/common/Component';

export default class TabItem extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	view() {
		const { active, data } = this.attrs;

		if (!active) {
			return null;
		}

		return (
			<iframe
				src={data.embedUrl()}
				width='120%'
				frameborder='0'
				marginwidth='0'
				marginheight='0'
				allowfullscreen
				webkitallowfullscreen
				mozallowfullscreen
				msallowfullscreen></iframe>
		);
	}
}
